// extracted by mini-css-extract-plugin
export var attachment = "_rb-a";
export var emailContainer = "_rb-4";
export var emailContentPaddedContainer = "_rb-b";
export var emailHeader = "_rb-6";
export var emailIframe = "_rb-3";
export var emailInfoIcon = "_rb-9";
export var emailShortenedSummary = "_rb-e";
export var infoDropdown = "_rb-0";
export var infoRowBoundedContent = "_rb-d";
export var internal = "_rb-5";
export var merchant = "_rb-8";
export var messageInputContainer = "_rb-h";
export var normal = "_rb-7";
export var replyCard = "_rb-f";
export var subtleButton = "_rb-1";
export var subtleButtonIconContainer = "_rb-2";
export var toggleViewRepliesButton = "_rb-c";
export var wrappingText = "_rb-g";